import { ActionStore, DashboardDatatableStore } from '@stores/models/store';
import { SET_DASHBOARD_DATATABLE } from '@stores/reducers/Reducers';

const initialState: DashboardDatatableStore = {
  limit: 20,
  skip: 0,
  sort: undefined,
  filter: undefined,
};

const reducer = (
  state = initialState,
  action: ActionStore<DashboardDatatableStore>,
): DashboardDatatableStore => {
  switch (action.type) {
    case SET_DASHBOARD_DATATABLE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
